import { useEffect } from 'react';
import { setFacebookClickIdToCookie } from '../helpers/setFacebookClickIdToCookie';
import { setGoogleClickIdToCookie } from '../helpers/setGoogleClickIdToCookie';
import { setGoogleClickIdDateToCookie } from '../helpers/setGoogleClickIdDateToCookie';
import { setTrackingContextToCookie } from '../helpers/setTrackingContextToCookie';
import { setUtmTrackingParamsToCookie } from '../helpers/setUtmTrackingParamsToCookie';

export const useInitTrackingParams = (): void => {
  useEffect(() => {
    setGoogleClickIdToCookie();
    setGoogleClickIdDateToCookie();
    setFacebookClickIdToCookie();
    setUtmTrackingParamsToCookie();
    setTrackingContextToCookie();
  }, []);
};
